export enum Path {
    START = '/start',
    ERROR = '/error/:errorCode',
    RESERVATION = '/reservation',
    CANCEL_RESERVATION = '/cancel-reservation',
    RESTAURANT_MENU = '/menu',
}
